import { Flex } from '@mantine/core';

import { DateSlider } from '@/entities/DateSlider/DateSlider';

import { BookingCards } from '@/features/BookingCards/BookingCards';

import useAppStore from '@/shared/store/app.store';
import { useSettingsStore } from '@/shared/store/settings.store.ts';
import { LayoutRow } from '@/shared/uikit/layouts/LayoutRow';

export const BookUp = () => {
	const workTime = useSettingsStore((state) => state.workTime);
	const setDate = useAppStore((state) => state.setDate);

	if (!workTime) return; //TODO: fix workTime types

	return (
		<LayoutRow
			title={{
				title: { children: 'Забронировать', size: 'h4', fw: 800 },
			}}
			type="once"
		>
			<Flex direction="column" gap={16}>
				<DateSlider workTime={workTime} setDate={setDate} />
				<BookingCards />
			</Flex>
		</LayoutRow>
	);
};
